import { inPopDetailPage, utilTool, getQueryField } from './utils';

const globalData = {};

var elThemeStyle = document.getElementById('theme-style');
var mColorTheme =
    elThemeStyle &&
    elThemeStyle.innerHTML.match(/--color-theme:\s*([^:;]+?)\s*;/);

//  Add anchor configuration 
const defaultGlobalData = {
    registerUserType: 'BUYER',
    template: getQueryField('template') || 'standard',
    registration: {
        style: 'standard'
    },
    questionNaire: {
        style: 'standard'
    },
    themeColor: (mColorTheme && mColorTheme[1]) || '#03c9ff',
    hereApiKey:
        process.env.NODE_ENV !== 'production'
            ? '3Cna31BNpK4CkcWrjkbAafzz1Y3Pa_s3Z-aVBe10Uyg'
            : 'ossFwZuLtG6UBfU1nBYfnST0x6XhkGbLko7JKOhLYAA',
    scheduleAnchor: {
        name: 'schedule',
        loginCallback: null
    }
};

export const prepareData = function (data) {
    if (data === 'fetch') {
        return globalData;
    }
    for (let key in globalData) {
        if (globalData.hasOwnProperty(key)) {
            delete globalData[key];
        }
    }
    if (data) {
        Object.assign(globalData, defaultGlobalData, data);
    } else {
        try {
            const globalForm = window.GLOBAL_DATA;
            if (globalForm) {
                Object.assign(
                    globalData,
                    defaultGlobalData,
                    window.GLOBAL_DATA
                );
            }
        } catch (e) {
            console.error(e);
        }
    }
    if (globalData.rulesMap) {
        //change attribute name
        globalData.terminologyMap = globalData.rulesMap;
        delete globalData.terminologyMap;
    }
    globalData.template =
        (globalData.themeConfig || {}).templateValue || globalData.template;
    globalData.is_virtual_lead = utilTool.getCookie('is_virtual_lead')
        ? true
        : false;
    let thirdPartAuthor = globalData.thirdPartAuthor || {},
        fbid = thirdPartAuthor.facebookClientId,
        ggid = thirdPartAuthor.googleClientId;
    if (fbid && fbid != 0) {
        globalData.facebook = true;
        globalData.FBAppId = fbid;
    } else {
        globalData.facebook = false;
    }
    if (ggid && ggid != 0) {
        globalData.google = true;
        globalData.googleAppId = ggid;
    } else {
        globalData.google = false;
    }
    globalData.licenseName = globalData.licenseName || 'License ID: ';
    if (utilTool.isObject(globalData.lazyMode)) {
        globalData.lazyMode = globalData.lazyMode.lazyMode;
    }
    if (inPopDetailPage || globalData.lazyMode === undefined) {
        globalData.lazyMode = false;
    }

    //resolve track
    if (globalData.hasOwnProperty('lpTrack')) {
        if (globalData.lpTrack.ga) {
            globalData.track.ga = globalData.lpTrack.ga;
        }
        if (globalData.lpTrack.pixel) {
            globalData.track.pixel = globalData.lpTrack.pixel;
        }
    }
    if (globalData.map) {
        globalData.map.type = globalData.map.type || 'here';
    } else {
        globalData.map = {
            type: 'here'
        };
    }
    globalData.house = globalData.house || {};
    if (globalData.house.showListingPrice === undefined) {
        globalData.house.showListingPrice = globalData.soldPrice
            ? globalData.soldPrice.soldListingPriceMark == 1
            : true;
    }
    if (globalData.house.showSoldPrice === undefined) {
        globalData.house.showSoldPrice = globalData.soldPrice
            ? globalData.soldPrice.soldListingPriceMark == 1
            : true;
        if (
            globalData.soldPrice &&
            globalData.soldPrice.soldListingPriceMark == 2
        ) {
            globalData.house.showSoldPrice = true;
        }
    }
    if (globalData.house.showAgentName === undefined) {
        globalData.house.showAgentName = globalData.hideAgentName
            ? !globalData.hideAgentName.hideAgentName
            : true;
    }
    //  Users registered on the details page are seller
    // if (globalData.pageKey === 'listing-detail-sold') {
    //     globalData.registerUserType = 'SELLER';
    // }
    updateRegisterTypeByPageKey(globalData.pageKey);

    window.addEventListener('message', ({ data }) => {
        if (data.action === 'site_global_data') {
            Object.assign(globalData, data.data);
        }
    });
    if (!globalData.creatorId) {
        let creatorIdEl = document.getElementById('creatorId');
        globalData.creatorId = parseInt(creatorIdEl && creatorIdEl.value);
    }
    let evaluationSite = document.getElementById('evaluationSite');
    globalData.evaluationSite = parseInt(
        evaluationSite && evaluationSite.value
    );
    if (
        globalData.openMultilingual &&
        globalData.sysLanguageList &&
        globalData.sysLanguageList.length > 1
    ) {
        globalData.translatorType = 'chime';
    } else if (globalData.language && globalData.language.show) {
        globalData.translatorType = 'googlePlugin';
    }

    // globalData.wordPressSSR = true;
    // globalData.widget = false;

    return globalData;
};

//  according to purchaseType to modify  registerUserType (in md-detail-info created)
export function updateRegisterUserType(purchaseType, globalData) {
    //  Record registerUserType whether it is passed purchaseType to set 
    globalData.isRegUserTypeByPurchaseType = true;
    switch (purchaseType) {
        case 'For Sale':
            globalData.registerUserType = 'BUYER';
            break;
        case 'For Rent':
            globalData.registerUserType = 'RENTAL';
            break;
        case 'For Sold':
            globalData.registerUserType = 'SELLER';
            break;
        default:
            break;
    }
}

//  according to  globalData.pageKey  renew 
let SELLER_PAGE_KEY = ['listing-detail-sold', 'sell', 'evaluation'];
export function updateRegisterTypeByPageKey(pageKey) {
    if (SELLER_PAGE_KEY.includes(pageKey)) {
        console.log('--updateRegisterTypeByPageKey----SELLER--');
        globalData.registerUserType = 'SELLER';
    }
}

// Data related to the server 
export default globalData;
